module.exports = __webpack_public_path__ + "static/media/waiting.6c175f7e.svg";